/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BusinessIntelligenceBiReportingComponent = {
  id?: number
  HandledByTimestamp?: string
  HandledBy?: BusinessIntelligenceBiReportingComponent.HandledBy
}
export namespace BusinessIntelligenceBiReportingComponent {
  export enum HandledBy {
    ROBIN_W = 'Robin W',
    COEN_B = 'Coen B',
    JORRIT_F = 'Jorrit F',
    OVERIG = 'Overig',
    NOORD = 'Noord',
    MIDDEN = 'Midden',
    LANDELIJK = 'Landelijk',
    ZUID = 'Zuid',
    ASSESSMENT = 'Assessment',
  }
}
